// extracted by mini-css-extract-plugin
export default {"featuresCard":"featuresTab_featuresCard__xDlqc","featuresImage":"featuresTab_featuresImage__cK+zs"};